import React, { FC, useEffect, useState } from 'react';
import { UnifiedKeypoints } from '@exerai/vision-engine-web';
import { ScanSessionResultsInsights, SideGaitResultsInsights } from '@/common/types';
import { SideGaitResultsInsightsDisplay } from './SideGaitResultsInsightsDisplay';
import { resultsInsightsAreSideGait } from './utils';

interface ResultsInsightsContainerProps {
    resultsInsights: ScanSessionResultsInsights;
    poseLog: UnifiedKeypoints[];
    handleGoToClick: (n: number) => void;
}

export const ResultsInsightsDisplayContainer: FC<ResultsInsightsContainerProps> = (props) => {
    const { resultsInsights } = props;
    const [sideGaitResultsInsights, setSideGaitResultsInsights] = useState<SideGaitResultsInsights>();

    useEffect(() => {
        if (!resultsInsightsAreSideGait(resultsInsights)) {
            return;
        }
        setSideGaitResultsInsights(resultsInsights);
    }, [resultsInsights]);

    return (
        <>
            {sideGaitResultsInsights && (
                <SideGaitResultsInsightsDisplay {...props} resultsInsights={sideGaitResultsInsights} />
            )}
        </>
    );
};
